module.exports = __webpack_public_path__ + "static/media/mind-share.f25fd448.svg";